import { markRaw } from 'vue'
import widgetType from '@/constants/widgetType'
import Events from '@/components/next-gen/widget-pages/EventsWidgetPage.vue'
import News from '@/components/next-gen/widget-pages/NewsWidgetPage.vue'
import StudentLearningMomentsWidgetPage from '@/components/next-gen/widget-pages/StudentLearningMomentsWidgetPage.vue'
import StudentAcademicReportsWidgetPage
    from '@/components/next-gen/widget-pages/StudentAcademicReportsWidgetPage.vue'
import StudentDueWorkWidgetPage
    from '@/components/next-gen/widget-pages/StudentDueWorkWidgetPage.vue'

export default Object.freeze({
    [widgetType.events]: markRaw(Events),
    [widgetType.news]: markRaw(News),
    [widgetType.studentDueWork]: markRaw(StudentDueWorkWidgetPage),
    [widgetType.studentLearningMoments]: markRaw(StudentLearningMomentsWidgetPage),
    [widgetType.studentAcademicReports]: markRaw(StudentAcademicReportsWidgetPage),
})
